import moment from "moment";
import { isEmpty } from "lodash";

export const expenseColors = {
  1: "bg-gray-300 border border-black",
  2: "bg-green-400",
  3: "bg-blue-500",
  4: "bg-purple-400",
  5: "bg-red-600",
  6: "bg-black",
  7: "bg-yellow-300"
};

export const totalExpenseColors = {
  personalDistance: "bg-red-600",
  fineAmount: "bg-red-600",
  amountOwed: "bg-green-700",
  amountTransfered: "bg-green-400",
  amountDue: "bg-black"
};

export const columnTitles = weekDate => {
  const daysOfTheWeek = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"];

  return [
    "",
    ...daysOfTheWeek.map((item, index) => {
      return `${item} ${moment(weekDate)
        .add(index, "day")
        .date()} ${moment(weekDate)
        .add(index, "day")
        .format("MMMM")}`;
    })
  ];
};

export function addDates(daysDiff, lastDate, acc) {
  let datesInBetween = [];

  while (daysDiff >= 1) {
    let nextDay = new Date(lastDate);

    nextDay = moment(nextDay).add(daysDiff, "days");
    datesInBetween.push(moment(nextDay).format("YYYY-MM-DD"));
    daysDiff--;
  }
  datesInBetween.reverse().forEach(tabItem => {
    acc[tabItem] = [];
  });
  return acc;
}

const getTotalCostyFromStatusId = (weeklyList, statusId) => {
  const weeklyFiltered = weeklyList && weeklyList.filter(item => item.status && item.status.id === statusId);
  const amount = item => {
    const type = item.type || {};
    const sign = type.CRÉDIT ? -1 : 1;
    return sign * item.price;
  };

  const sum = (prev, next) => {
    return prev + next;
  };

  return weeklyFiltered && !isEmpty(weeklyFiltered.map(amount))
    ? Number.parseFloat(weeklyFiltered.map(amount).reduce(sum)).toFixed(2)
    : 0;
};

export const summaryApprovalItems = weeklyData => [
  {
    approvalStatusId: 1,
    totalCost: getTotalCostyFromStatusId(weeklyData, 1),
    label: "En attente",
    style: `${expenseColors[1]} text-black`
  },
  {
    approvalStatusId: 5,
    totalCost: getTotalCostyFromStatusId(weeklyData, 5),
    label: "Rejetées",
    style: `${expenseColors[5]}`
  },
  {
    approvalStatusId: 2,
    totalCost: getTotalCostyFromStatusId(weeklyData, 2),
    label: "Prévalidées manager",
    style: `${expenseColors[2]}`
  },
  {
    approvalStatusId: 4,
    totalCost: getTotalCostyFromStatusId(weeklyData, 4),
    label: "Refusées",
    style: `${expenseColors[4]}`
  },
  {
    approvalStatusId: 3,
    totalCost: getTotalCostyFromStatusId(weeklyData, 3),
    label: "Validées comptable",
    style: `${expenseColors[3]}`
  },
  {
    approvalStatusId: 7,
    totalCost: getTotalCostyFromStatusId(weeklyData, 7),
    label: "Remboursées",
    style: `${expenseColors[7]}`
  },
  {
    approvalStatusId: 6,
    totalCost: getTotalCostyFromStatusId(weeklyData, 6),
    label: "Supprimée",
    style: `${expenseColors[6]}`
  }
];

export const totalDetailsItems = [
  {
    approvalState: "personalDistance",
    totalCost: 34,
    label: "Km persos",
    style: `${totalExpenseColors["personalDistance"]}`
  },
  {
    approvalState: "fineAmount",
    totalCost: 434,
    label: "Amende",
    style: `${totalExpenseColors["fineAmount"]}`
  },
  {
    approvalState: "amountOwed",
    totalCost: 664,
    label: "Total à rembourser",
    style: `${totalExpenseColors["amountOwed"]}`
  },
  {
    approvalState: "amountTransfered",
    totalCost: 90,
    label: "Refusé",
    style: `${totalExpenseColors["amountTransfered"]}`
  },
  {
    approvalState: "amountDue",
    totalCost: 49,
    label: "Reste à payer",
    style: `${totalExpenseColors["amountDue"]}`
  }
];



// WEBPACK FOOTER //
// src/modules/presence/expenseReports/expenseReportsWeekly/weeklyDetails/WeeklyDetails.utils.js